import styled from 'styled-components'

const Avatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.color.turquoise};
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  min-width: ${props => props.size}px;
  min-height: ${props => props.size}px;
  border-radius: 50%;
  cursor: ${p => (p.onClick ? 'pointer' : 'auto')};
  font-size: 20px;
  overflow: hidden;
  background: ${p => p.url && `url(${p.url}) center/cover`};

  img {
    margin: 0;
  }
`

export const Styled = {
  Avatar,
}